import {Modal, Button} from 'react-bootstrap'
import React from 'react'
import {t} from '../../helpers/translate'

class ModalComponent extends React.Component {

  constructor(props) {
    super(props);
  }

  close() {
    this.props.onClose(this.props.resetDataOnClose);
  }

  handleOptionalButton() {
    this.props.onSubmit();
  }

  render() {
    const messageType = this.props.messageType ? this.props.messageType : 'info';
    const buttonName = this.props.buttonName;
    const closeButton = this.props.closeButton;

    return <Modal bsSize={this.props.size} show={this.props.show} onHide={this.close.bind(this)}>
      <Modal.Header closeButton>
        <Modal.Title className={`${messageType}-title`}>{this.props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={`${messageType}-body`}>
        <div>{this.props.body}</div>
      </Modal.Body>
      <Modal.Footer>
          <Button className="button-primary" onClick={this.close.bind(this)}>{closeButton ? closeButton : t('Close')}</Button>
          {buttonName && <Button className="button-secondary" onClick={this.handleOptionalButton.bind(this)}>{buttonName}</Button>}
      </Modal.Footer>
    </Modal>;
  }
}

ModalComponent.displayName = 'ModalComponent';
export default ModalComponent;



// WEBPACK FOOTER //
// ./src/components/common/ModalComponent.js